import {
  CellRenderers,
  ColumnType,
  PathTypedColDef,
} from '@/top-level-tot/utils/create-columns/types';
import { centsBasedCurrencyValueFormatter } from '@/top-level-tot/utils/create-columns/value-formatters/currency-value-formatter';
import {
  ColDef,
  ICellRendererFunc,
  Module,
  SideBarDef,
} from '@ag-grid-community/core';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { DateCellRenderer } from './cell-renderers/date-cell-renderer';
import { EstimatedTaxCellRenderer } from './cell-renderers/estimated-tax-cell-renderer';
import { StatusCellRenderer } from './cell-renderers/status-cell-renderer';

/**
 * https://www.ag-grid.com/javascript-data-grid/modules/
 * Extensions/addons for the grid/table itself
 */
export const modules: Array<Module> = [
  /**
   * https://www.ag-grid.com/react-data-grid/context-menu/
   * To enable a custom context menu upon right clicking a cell/row within the table
   */
  MenuModule,
  ColumnsToolPanelModule,
  // https://www.ag-grid.com/react-data-grid/server-side-model-pagination/
  ServerSideRowModelModule,
];

/**
 * https://www.ag-grid.com/javascript-data-grid/components/#registering-custom-components
 * Extending this will allow for more options for how header and data cells render.
 */
export const agGridComponents: Record<CellRenderers, ICellRendererFunc> = {
  statusCell: StatusCellRenderer,
  dateCell: DateCellRenderer,
  estimatedTaxCell: EstimatedTaxCellRenderer,
};

/**
 * https://www.ag-grid.com/javascript-data-grid/column-definitions/
 * Extending this will provide additional context to a column.
 */
export const agGridColumnTypes: Record<ColumnType, Partial<PathTypedColDef>> = {
  centBasedCurrency: {
    valueFormatter: centsBasedCurrencyValueFormatter,
  },
};

/**
 * https://www.ag-grid.com/archive/26.2.0/javascript-data-grid/tool-panel-columns/#section-visibility
 * Tooling the sidebar, so that only the columns display toggling is enabled
 */
export const agGridSidebar: SideBarDef = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true,
        suppressColumnFilter: true,
        suppressColumnMove: true,
      },
    },
  ],
};

export const defaultColDef: ColDef = {
  flex: 1,
  minWidth: 90,
  suppressMenu: true, // Disabled the action menu per column
  sortable: false,
  resizable: true,
};
